import { IPart } from 'app/shared/model/part.model';
import { IMaintenanceVehicle } from 'app/shared/model/maintenance-vehicle.model';

export interface IMaintenancePart {
  id?: number;
  proofContentType?: string | null;
  proof?: string | null;
  objectKey?: string | null;
  description?: string | null;
  km?: number | null;
  age?: number | null;
  hour?: number | null;
  replaced?: boolean | null;
  part?: IPart | null;
  maintenanceVehicle?: IMaintenanceVehicle | null;
}

export const defaultValue: Readonly<IMaintenancePart> = {
  replaced: false,
};
